var styles = {"marks":"RangeMarks_marks_158cp_1","mark":"RangeMarks_mark_158cp_1","rakeback":"RangeMarks_rakeback_158cp_27"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
